/* unplugin-vue-components disabled */import { render } from "./OpticalPathInferenceRender.vue?vue&type=template&id=63a45826&scoped=true"
import script from "./OpticalPathInferenceRender.vue?vue&type=script&lang=js"
export * from "./OpticalPathInferenceRender.vue?vue&type=script&lang=js"

import "./OpticalPathInferenceRender.vue?vue&type=style&index=0&id=63a45826&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a45826"]])

export default __exports__